import DropdownSelectColumns from './DropdownSelectColumns-redux';

export default DropdownSelectColumns;
